import { render, staticRenderFns } from "./DeleteExpenditure.vue?vue&type=template&id=8bb20d14"
import script from "./DeleteExpenditure.vue?vue&type=script&lang=js"
export * from "./DeleteExpenditure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports